import styled from 'styled-components';
import { v2Colors, v2FontFamily } from './styles/tokens';

export const PaymentPeriodWrapper = styled.div`
  &:hover {
    background-color: transparent;
  }

  .general-input-error {
    margin-top: 6px;
    font-size: 13px;
    font-weight: 500;
    color: ${v2Colors.danger};
    text-align: center;
  }
`;

export const PaymentPeriodHeading = styled.p`
  margin: 0 0 8px;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${v2Colors.textMuted};
`;

export const PaymentPeriodTrack = styled.div`
  position: relative;
  display: flex;
  max-width: 320px;
  margin: 0 auto;
  padding: 3px;
  background: ${v2Colors.surface};
  border: 1px solid ${v2Colors.border};
  border-radius: 12px;
`;

export const PaymentPeriodThumb = styled.span`
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(50% - 3px);
  height: calc(100% - 6px);
  background: ${v2Colors.primary};
  border-radius: 9px;
  opacity: ${(props) => (props.$active ? 1 : 0)};
  transform: translateX(${(props) => (props.$active === 2 ? '100%' : '0')});
  transition: transform 220ms ease, opacity 220ms ease;
`;

export const PaymentPeriodOption = styled.button`
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  z-index: 1;
  flex: 1;
  padding: 9px 12px;
  border: none;
  outline: none;
  background: transparent;
  border-radius: 9px;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => (props.$active ? '#fff' : v2Colors.textMuted)};
  cursor: pointer;
  transition: color 220ms ease;

  &:hover {
    background: transparent;
  }
`;
